<script>

import axios from "@/axios";

export default {
  data() {
    return {
    };
  },
  methods: {
    getToken() {
      let token
      axios.get(`/GetToken?rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`)
        .then((response) => {
          token = response.data
          window.open(`https://dashboard.mitta.cl/dashboard.aspx?` +
              `contrut=${token}`,
              "blank");
          history.back();
        })
    }
  },
  mounted() {
    this.getToken()
  }
};
</script>

<template> 
  <div></div>
</template>

<style>
</style>
